<template lang="html">
  <div
    v-tracking-context="{ content_element: 'filter_summary' }"
    class="filter-summary typo-sans"
  >
    <div class="row small-collapse large-uncollapse">
      <div class="column small-12">
        <h2 class="filter-summary__headline">
          <span class="filter-summary__total js-filter-summary__total">
            {{ headline || initialHeadline }}
          </span>
          <span class="filter-summary__pills">
            <span
              v-for="tag in checkedTags"
              :key="tag.key"
              class="button pill with-icon filter-summary__pill"
            >
              <span class="text-overflow">{{ tag.label }}</span>
              <span
                class="pill__delete"
                @click="searchProfileRemoveTag(tag.key)"
              >
                <svg-icon
                  icon-name="close"
                  class-name="icon--small"
                />
              </span>
            </span>
            <span
              v-for="tag in searchProfile.customTags"
              :key="tag"
              class="button pill with-icon filter-summary__pill"
            >
              <span class="text-overflow">{{ tag }}</span>
              <span
                class="pill__delete"
                @click="searchProfileRemoveCustomTag(tag)"
              >
                <svg-icon
                  icon-name="close"
                  class-name="icon--small"
                />
              </span>
            </span>
          </span>
        </h2>

        <div class="filter-summary__edit-actions js-filter-search-term">
          <div>
            <a
              href="#"
              class="ac-link--tertiary filter-summary__edit-filter js-filter-summary__reset"
              @click.prevent="searchProfileClear"
            >
              {{ 'client.filter_summary.clear' | t }}
              <svg-icon icon-name="trash" />
            </a>
          </div>
        </div>

        <div class="filter-summary__actions row is-collapse-child">
          <button
            v-click-track="{ action_type: 'filter_toggle', event_element: 'filter_edit' }"
            type="button"
            class="filter-summary__action small-5 medium-4 large-2"
            :class="{ 'filter-summary__action--active': isFilterOpen }"
            @click="toggleFilter"
          >
            {{ 'client.filter_summary.edit' | t }}
            <svg-icon
              icon-name="chevron-down"
              class-name="icon--small filter-summary__action-toggle"
            />
          </button>
          <div
            v-tracking-context="{ event_element: 'sort_edit' }"
            class="filter-summary__sort-wrapper filter-summary__action small-2 medium-4"
          >
            <select
              v-model="sort"
              class="filter-summary__sort"
              name="sort"
            >
              <option
                v-for="(val, key) in sortOptions"
                :key="key"
                :value="key"
              >
                {{ val }}
              </option>
            </select>
            <div
              v-click-track="{ action_type: 'sort_toggle' }"
              class="filter-summary__sort-toggle"
              @click="toggleSort"
            >
              <span class="filter-summary__sort-value">{{ sortName }}</span>
              <svg-icon
                icon-name="sort-arrows"
                class-name="icon--big filter-summary__sort-icon"
              />
            </div>
            <transition
              name="dropdown"
            >
              <ul
                v-if="sortVisible"
                class="filter-summary__sort-dropdown"
              >
                <li
                  v-for="(val, key) in sortOptions"
                  :key="key"
                  v-click-track="{ action_type: 'sort_select', target: `#${key}` }"
                  class="filter-summary__sort-option"
                  :class="{'filter-summary__sort-option--active': key === $store.state.sort }"
                  @click="onClickOption(key)"
                >
                  {{ val }}
                </li>
              </ul>
            </transition>
          </div>
          <button
            v-click-track="{ action_type: 'search_save', event_element: 'search_save' }"
            type="button"
            class="filter-summary__action small-5 medium-4"
            @click="saveSearch"
          >
            {{ saveSearchText | t }}
            <svg-icon icon-name="save" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'
import jump from 'jump.js-cancelable'
import { fromPairs } from 'lodash-es'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

import { STATUS_5 } from '@/user'

MediaQuery._init()

export default {
  props: {
    initialHeadline: { type: String, default: '' },
    saveCurrent: { type: Boolean, required: true },
    saveSearchUrl: { type: String, required: true }
  },
  data () {
    return {
      headline: null,
      sortVisible: false,
      sortOptionNames: this.$options.filters.t('client.filter_summary.sort'),
      sortOptionsOrder: this.$options.filters.t('client.filter_summary.sort_order')
    }
  },
  computed: {
    ...mapGetters(['checkedTags', 'isUserStatus']),
    ...mapState(['searchProfile', 'isFilterOpen']),
    sortOptions () {
      return fromPairs(this.sortOptionsOrder.map(option => [option, this.sortOptionNames[option]]))
    },
    sortName () {
      return this.sortOptions[this.$store.state.sort]
    },
    saveSearchText () {
      if (this.isUserStatus(STATUS_5)) {
        return 'client.filter_summary.save_search'
      } else {
        return 'client.filter_summary.login_and_save'
      }
    },
    sort: {
      get () { return this.$store.state.sort },
      set (newSort) { this.$store.commit('sortSet', newSort) }
    }
  },
  mounted () {
    EventBus.on(`filter-settings:headline`, (_event, headline) => {
      this.headline = headline
    })

    if (this.saveCurrent) {
      this.saveSearch()
    }
  },
  methods: {
    ...mapActions(['searchProfileSave']),
    ...mapMutations(['filterClose', 'searchProfileClear', 'searchProfileRemoveTag', 'searchProfileRemoveCustomTag', 'sortSet']),
    onClickOption (key) {
      this.$store.commit('sortSet', key)
      this.toggleSort()
    },
    filterToggle () {
      this.sortVisible = false
      this.$store.commit('filterToggle')
    },
    toggleSort () {
      if (!this.sortVisible) {
        this.filterClose()
      }

      this.sortVisible = !this.sortVisible
    },
    saveSearch () {
      this.searchProfileSave({ apiUrl: this.saveSearchUrl })
    },
    toggleFilter () {
      if (!this.isFilterOpen && MediaQuery.current === 'large') {
        this.$nextTick(() => {
          jump.jump('.result__list-wrapper', {
            duration: distance => Math.max(Math.abs(distance), 300)
          })
        })
      }

      this.filterToggle()
    }
  }
}
</script>

<style lang='scss' scoped>
.filter-summary__sort-dropdown {
  transition: 0.3s;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
